import { StrategyItem } from '../../molecules/strategy'

export type Selected = 'yes' | 'no' | 'unavailable'

export type Strategy = {
  id: string
  name: string
  selected: Selected
}

export type Props = {
  onChange: (name: string, value: boolean) => void
  readonly?: boolean
  strategies: Strategy[]
}

export const StrategySelector = ({ onChange, readonly, strategies }: Props) => (
  <>
    {strategies.map(strategy => (
      <StrategyItem
        key={strategy.id}
        name={strategy.name}
        readonly={readonly}
        selected={strategy.selected}
        onChange={val => onChange(strategy.id, val)}
      />
    ))}
  </>
)
